//-------------------
// is object changed
//-------------------
export default function isObjectChanged(original, now) {
  // console.log("---------------------------");
  // console.log("IN isObjectChanged");
  if (JSON.stringify(original) === JSON.stringify(now)) {
    return false;
  } else {
    return true;
  }
}
